import { createConsola } from 'consola'

export default defineNuxtPlugin(() => {
  const logger = createConsola().withTag('mm:app')
  logger.info('Ready!')

  if (typeof window !== 'undefined')
    (window as unknown as { $consola: typeof logger }).$consola = logger

  return {
    provide: {
      logger,
    },
  }
})
